import httpClient from '../../utils/httpClient';

export const updateUser = async (data) => {
  return await httpClient.put('/user', { ...data });
};

export const deleteUser = async (data) => {
  return await httpClient.delete('/user', { ...data });
};
